import React, { useState, useEffect } from 'react';
import HeaderSection from './HeaderSection';
import Logo from "../image/StayCool.png";
import LoadingScreen from './LoadingScreen';

const Connector = () => {
  const [showContent, setShowContent] = useState(false);

  // Persisted state for HeaderSection
  const [searchData, setSearchData] = useState({
    searchParams: null,
    hotelList: [],
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 2000); 
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="font-poppins">
      {!showContent ? (
        <LoadingScreen
          logo={Logo}
          fadeDuration={1500}
          totalDuration={2000}
          backgroundColor="bg-[#f8f8f8]"
          size="w-64 h-64 object-contain"
        />
      ) : (
        <HeaderSection
          searchData={searchData}
          setSearchData={setSearchData}
        />
      )}
    </div>
  );
};

export default Connector;